import accordionSlotRecipe from "./components/Accordion";
import alertSlotRecipe from "./components/Alert";
import badgeRecipe from "./components/Badge";
import buttonRecipe from "./components/Button";
import checkboxSlotRecipe from "./components/Checkbox";
import drawerSlotRecipe from "./components/Drawer";
import fieldSlotRecipe from "./components/Field";
import flexRecipe from "./components/Flex";
import inputRecipe from "./components/Input";
import linkRecipe from "./components/Link";
import menuRecipe from "./components/Menu";
import { modalSlotRecipe } from "./components/Modal";
import nativeSelectRecipe from "./components/NativeSelect";
import pinInputSlotRecipe from "./components/PinInput";
import progressCircleSlotRecipe from "./components/ProgressCircle";
import radioCardSlotRecipe from "./components/RadioCard";
import radioGroupSlotRecipe from "./components/RadioGroup";
import radioMarkRecipe from "./components/RadioMark";
import selectSlotRecipe from "./components/Select";
import skeletonRecipe from "./components/Skeleton";
import stepperRecipe from "./components/Stepper";
import tabsSlotRecipe from "./components/Tabs";
import tagSlotRecipe from "./components/Tag";
import textRecipe from "./components/Text";
import textareaRecipe from "./components/Textarea";
import tooltipSlotRecipe from "./components/Tooltip";

// Recipes that contain legacy variants we'll need to clean up.
const legacyRecipes = {
  badge: badgeRecipe,
  button: buttonRecipe,
  input: inputRecipe,
  link: linkRecipe,
  radioMark: radioMarkRecipe,
  skeleton: skeletonRecipe
};

// ONLY recipes valid with Bark - otherwise add to legacy.
export const recipes = {
  ...legacyRecipes,
  flex: flexRecipe,
  text: textRecipe,
  textarea: textareaRecipe
};

// Recipes that contain legacy variants we'll need to clean up.
const legacySlotRecipes = {
  alert: alertSlotRecipe,
  checkbox: checkboxSlotRecipe,
  dialog: modalSlotRecipe,
  drawer: drawerSlotRecipe,
  field: fieldSlotRecipe,
  menu: menuRecipe,
  nativeSelect: nativeSelectRecipe,
  radioGroup: radioGroupSlotRecipe,
  stepper: stepperRecipe,
  steps: stepperRecipe,
  tabs: tabsSlotRecipe,
  tag: tagSlotRecipe
};

// ONLY recipes valid with Bark - otherwise add to legacy.
export const slotRecipes = {
  ...legacySlotRecipes,
  accordion: accordionSlotRecipe,
  pinInput: pinInputSlotRecipe,
  progressCircle: progressCircleSlotRecipe,
  radioCard: radioCardSlotRecipe,
  select: selectSlotRecipe,
  tooltip: tooltipSlotRecipe
};
